import {shareReplay} from 'rxjs';
import {map, filter} from 'rxjs/operators';
import {marginCurrencies$, marginPairs$} from '@px/streams/config';

export const crossLeverage$ = marginPairs$.pipe(
  map((marginTradings) => marginTradings?.[0]?.leverage || 5),
  shareReplay(1)
);

export const marginOptions$ = marginPairs$.pipe(map((items) => items.map((item) => ({value: item.symbol, text: item.displaySymbol}))));
export const marginBorrowOptions$ = marginCurrencies$.pipe(
  map((items) => items.filter((item) => item.canBorrow).map((item) => ({value: item.currency, text: item.currency, name: item.name, valuePrecision: item.valuePrecision})))
);
export const marginRepayOptions$ = marginCurrencies$.pipe(
  map((items) => items.filter((item) => item.canRepay).map((item) => ({value: item.currency, text: item.currency, name: item.name, valuePrecision: item.valuePrecision})))
);
export const marginTransferInOptions$ = marginCurrencies$.pipe(map((items) => items.filter((item) => item.canTransferIn).map((item) => ({value: item.currency, text: item.currency}))));
export const marginTransferOutOptions$ = marginCurrencies$.pipe(map((items) => items.filter((item) => item.canTransferOut).map((item) => ({value: item.currency, text: item.currency}))));
export const marginCurrenciesOptions$ = marginCurrencies$.pipe(map((items) => items.map((item) => ({value: item.currency, text: item.currency}))));

export const marginMaxLeverage$ = marginPairs$.pipe(
  filter((pairs) => pairs.length > 0),
  map((pairs) => {
    const items = pairs.map(({leverage}) => leverage);
    return Math.max(...items);
  })
);
